// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"873":"62b8a082","940":"c4b357dc"}[chunkId] + ".chunk.js";
};